import { ApiError } from "../types";

export function isApiError(error: any): error is ApiError {
  return error?.response?.data?.error != null;
}
